
import React from "react";
import { Form } from "@/components/ui/form";
import { MedewerkerResponse, MedewerkerInsert, MedewerkerUpdate } from "@/integrations/supabase/medewerkerTypes";
import { useMedewerkerForm } from "./form/useMedewerkerForm";
import PersonalInfoFields from "./form/PersonalInfoFields";
import PasswordField from "./form/PasswordField";
import RoleField from "./form/RoleField";
import FormActions from "./form/FormActions";

interface MedewerkerFormProps {
  medewerker?: MedewerkerResponse;
  onSubmit: (values: MedewerkerInsert | MedewerkerUpdate) => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

const MedewerkerForm = ({ 
  medewerker, 
  onSubmit, 
  onCancel, 
  isSubmitting 
}: MedewerkerFormProps) => {
  const { form, handleSubmit, isEditMode } = useMedewerkerForm(medewerker, onSubmit);

  return (
    <Form {...form}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <PersonalInfoFields form={form} />

        <div className="grid md:grid-cols-2 gap-4">
          <PasswordField form={form} isEditMode={isEditMode} />
          <RoleField form={form} />
        </div>

        <FormActions onCancel={onCancel} isSubmitting={isSubmitting} isEditMode={isEditMode} />
      </form>
    </Form>
  );
};

export default MedewerkerForm;
